<template>
    <div>
        <v-card >
          <v-card-title><span class="pink--text">Family Details</span>
            <v-spacer></v-spacer> <v-icon class="red--text" @click="$emit('closeInfo')">mdi-close</v-icon></v-card-title>
            <v-form @submit.prevent="submitForm" class="pa-2">
              <v-row>
        <v-col cols="12" md="3">
          <v-autocomplete v-model="MotherDetails" :items="LookupArr(dropDownList?.parentDetaillist)" item-text="text" item-value="value" label="Mother Detail"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete v-model="FatherDetails" :items="LookupArr(dropDownList?.parentDetaillist)" item-text="text" item-value="value" label="Father Detail"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-select v-model="familyDetails.sisters" :items="dropDownList?.totalpersonslist" label="No.of.Sisters"></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-select v-model="familyDetails.brothers" :items="dropDownList?.totalpersonslist" label="No.of.Brothers"></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete v-model="FamilyFinancialStatus" :items="LookupArr(dropDownList?.financialStatus)" item-text="text" item-value="value" label="Financial Status"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete v-model="FamilyType" :items="LookupArr(dropDownList?.familyType)" item-text="text" item-value="value" label="Family Type"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete v-model="FamilyValue" :items="LookupArr(dropDownList?.familyValue)" item-text="text" item-value="value" label="Family Value "></v-autocomplete>
        </v-col>
        <v-col cols="12" md="12" class="d-flex justify-end">
            <v-btn type="submit" class="primary elevation-0"> Submit</v-btn>
          </v-col>
      </v-row>
    </v-form>
        </v-card>
    </div>
</template>
<script>
export default {
  data() {
    return {
        Indicator:"family",
       MotherDetails:"",
       FatherDetails:"",
       FamilyValue:"",
FamilyType:"",
FamilyValue:"",
FamilyFinancialStatus:""

    };
  },
  props:{
    familyDetails:{}, dropDownList: {}
  },
  methods: {
    assignvalue(){
      this.MotherDetails  = this.getKeyByValue(this.dropDownList.parentDetaillist, this.familyDetails.mother)
      this.FatherDetails  = this.getKeyByValue(this.dropDownList.parentDetaillist, this.familyDetails.father)
      this.FamilyFinancialStatus  = this.getKeyByValue(this.dropDownList.financialStatus, this.familyDetails.financial_Status)
      this.FamilyType  = this.getKeyByValue(this.dropDownList.familyType, this.familyDetails.familyType)
      this.FamilyValue  = this.getKeyByValue(this.dropDownList.familyValue, this.familyDetails.familyValue)

    },
    submitForm() {
      this.familyDetails.mother = this.MotherDetails
      this.familyDetails.father = this.FatherDetails
      this.familyDetails.financial_Status = this.FamilyFinancialStatus
      this.familyDetails.familyType = this.FamilyType
      this.familyDetails.familyValue = this.FamilyValue
        this.$emit("family",this.Indicator)
      // Handle form submission logic here, e.g., send data to an API or update the state
    }
  },
  mounted(){
    this.assignvalue()
  }
};
</script>
